/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

export {default, config} from '@webex/plugin-authorization-browser';
